import { Check, Palette } from 'shared/icons';
import { useTheme } from '../../hooks/useTheme';
import api from '../../services/api';
import Card from '../ui/Card';
import { useToast } from '../ui/Toast';

const ThemeSettings = () => {
    const { predefinedThemes, theme, selectPredefinedTheme } = useTheme();
    const toast = useToast();

    const handleSelectTheme = async (themeKey) => {
        const selectedTheme = predefinedThemes[themeKey];
        if (!selectedTheme) {
            return;
        }

        selectPredefinedTheme(themeKey);

        try {
            await api.activateUserTheme(selectedTheme.backend_id || themeKey);
        } catch (_error) {
            // Keep local theme selected even when backend persistence fails.
        }

        toast.success(`Tema "${selectedTheme.name}" aplicado`);
    };

    return (
        <Card>
            <div className="space-y-6">
                <div className="flex items-center gap-3">
                    <Palette size={24} className="text-black dark:text-white" />
                    <h2 className="text-xl font-bold text-black dark:text-white">Tema da Interface</h2>
                </div>

                <div>
                    <h3 className="mb-3 text-sm font-medium text-mono-700 dark:text-mono-300">Temas Padrao</h3>
                    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
                        {Object.entries(predefinedThemes).map(([key, themeData]) => (
                            <button
                                key={key}
                                type="button"
                                onClick={() => handleSelectTheme(key)}
                                className={`rounded-xl border-2 p-4 text-left transition-all hover:scale-[1.01] ${
                                    theme === key
                                        ? 'border-black bg-mono-50 dark:border-white dark:bg-mono-900'
                                        : 'border-mono-200 hover:border-mono-400 dark:border-mono-800 dark:hover:border-mono-600'
                                }`}
                            >
                                <div className="mb-3 flex gap-2">
                                    <div
                                        className="h-10 flex-1 rounded"
                                        style={{ backgroundColor: themeData.color_primary }}
                                    />
                                    <div
                                        className="h-10 flex-1 rounded"
                                        style={{ backgroundColor: themeData.color_secondary }}
                                    />
                                    <div
                                        className="h-10 flex-1 rounded"
                                        style={{ backgroundColor: themeData.color_accent }}
                                    />
                                </div>
                                <div className="flex items-center justify-between">
                                    <p className="text-sm font-medium text-black dark:text-white">{themeData.name}</p>
                                    {theme === key ? (
                                        <Check size={18} className="text-black dark:text-white" weight="bold" />
                                    ) : null}
                                </div>
                                <p className="mt-1 text-xs text-mono-500 dark:text-mono-400">{themeData.description}</p>
                            </button>
                        ))}
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default ThemeSettings;
